<script lang="ts">
  import AUButtonIcon from "component_library/components/svelte/ui/AUButtonIcon.svelte"
  import AUStack from "component_library/components/svelte/ui/AUStack.svelte"
  import AUText from "component_library/components/svelte/ui/AUText.svelte"
  import Close from "@autouncle/icons/dist/assets/close.svg?raw"
  import logo from "icons/branding/autouncle-logo-color.svg?raw"
  import Svg from "website_script/components/Svg.svelte"
  import type { PromptType, Settings } from "website_script/types/settings"
  import type { Texts } from "website_script/types/texts"
  import { getContext } from "svelte"

  export let onClose: (e: KeyboardEvent | MouseEvent) => void
  export let type: PromptType = "simple"

  const { close, poweredBy } = getContext<Texts>("texts")
  const { auCarUrl } = getContext<Settings>("settings")
</script>

<AUStack gap="md">
  <AUStack gap="xs">
    <AUStack
      layout="horizontal"
      gap="xs"
      justifyContent="space-between"
      alignItems="start"
    >
      <AUText color="default" font="body-base" weight="bold"
        ><slot name="title" /></AUText
      >
      <AUButtonIcon size="sm" sroText={close} icon={Close} onClick={onClose} />
    </AUStack>
    {#if type === "advanced"}
      <AUText color="body" font="body-small"><slot name="description" /></AUText
      >
    {/if}
  </AUStack>
  {#if type === "advanced"}
    <AUStack gap="xs">
      <slot name="action" />
      <AUText font="body-xsmall" align="center">
        {#if auCarUrl}
          <a
            href={auCarUrl}
            target="_blank"
            class="au-prompt__link"
            on:click={(e) => e.stopPropagation()}
          >
            {poweredBy}
            <Svg alt="AutoUncle" data={logo} height="10" />
          </a>
        {:else}
          {poweredBy}
          <Svg alt="AutoUncle" data={logo} height="10" />
        {/if}
      </AUText>
    </AUStack>
  {/if}
</AUStack>

<style>
  .au-prompt__link {
    display: inline-block;
    color: inherit;
    text-decoration: none;
  }

  .au-prompt__link:hover {
    color: inherit;
  }

  .au-prompt__link:focus-visible {
    outline-offset: 1px;
  }
</style>
